// From https://www.quirksmode.org/js/cookies.html

export type SameSiteValue = 'None' | 'Strict' | 'Lax';

export class CookieHelper {

    public create(name: string, value: string, days: number, sameSiteValue?: SameSiteValue) {

        let expires = '';
        let sameSite = '';

        if (days) {

            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();

        } else {

            expires = '';
        }

        if (sameSiteValue) {

            sameSite = '; sameSite=' + sameSiteValue;
        }

        const cookieValue = name + '=' + value + expires + sameSite + '; path=/';

        document.cookie = cookieValue;
    }

    public get(name: string) {

        const match = name + '=';

        const ca = document.cookie.split(';');

        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < ca.length; i++) {

            let c = ca[i];

            while (c.charAt(0) === ' ') {

                c = c.substring(1, c.length);
            }

            if (c.indexOf(match) === 0) {

                return c.substring(match.length, c.length);
            }
        }

        return null;
    }

    public remove(name: string) {

        this.create(name, '', -1);
    }
}
